module.exports = __webpack_public_path__ + "static/media/TS.96df5ab6.svg";